"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketDataFutures = exports.MarketDataSpot = exports.MarketData = void 0;
const constants_1 = require("../config/constants");
const binance_1 = require("../types/binance");
const formatted_1 = require("../utils/eventFilters/formatted");
const misc_1 = require("../utils/misc");
const typeGuards_1 = require("../utils/typeGuards");
class MarketData {
    constructor(params) {
        const { marketAssets } = params;
        this.marketAssets = marketAssets || new Map();
    }
    update(params) {
        const { marketData, events, exchangeInfo = this.exchangeInfo } = params;
        this.exchangeInfo = exchangeInfo;
        this.marketAssets = marketData || this.marketAssets;
        if (events === undefined)
            return;
        const assetsPriceFromEvents = this.getAssetsPriceFromEvents(events);
        Object.entries(assetsPriceFromEvents).forEach(([key, eventAsset]) => {
            const assetData = this.marketAssets.get(key);
            if (assetData === undefined) {
                this.marketAssets.set(key, MarketData.mergeAssets([{
                        assetId: key,
                        quotes: {}
                    }, eventAsset]));
                return;
            }
            this.marketAssets.set(key, MarketData.mergeAssets([
                assetData,
                eventAsset
            ]));
        });
    }
    get data() {
        return {
            marketAssets: this.marketAssets
        };
    }
    static insertQuote(asset, quotes) {
        return Object.assign(Object.assign({}, asset), { quotes: Object.assign(Object.assign({}, asset.quotes), quotes) });
    }
    static mergeAssets(marketAssets) {
        if (marketAssets[0] === undefined)
            return {
                assetId: '',
                quotes: {}
            };
        const r = marketAssets.slice(1).reduce((acc, asset) => {
            if (asset.assetId !== acc.assetId)
                return acc;
            return Object.assign(Object.assign({}, acc), { quotes: Object.assign(Object.assign({}, acc.quotes), asset.quotes) });
        }, marketAssets[0]);
        return r;
    }
    getAssetsPriceFromEvents(events) {
        const tickerEvents = this.filterEvents(events);
        const eventsGroupedByBaseAsset = tickerEvents.reduce((acc, event) => {
            const pair = (0, misc_1.filterExchageInfoBySymbol)({
                exchangeInfo: this.exchangeInfo,
                symbol: event.symbol
            });
            if (pair === undefined)
                return acc;
            const isInverse = (0, misc_1.isSymbolInverse)(pair.symbol);
            const isHasQuoteSymbol = (0, misc_1.filterExchageInfoBySymbol)({
                exchangeInfo: this.exchangeInfo,
                symbol: `${pair.quoteAsset}${pair.baseAsset}`
            }) !== undefined;
            const asset = acc[pair.baseAsset] || {
                assetId: pair.baseAsset,
                quotes: {}
            };
            const inverseAsset = acc[pair.quoteAsset] || {
                assetId: pair.quoteAsset,
                quotes: {}
            };
            const price = (0, typeGuards_1.isFuturesMarkPriceUpdate)(event) ? event.markPrice : event.lastPrice;
            const priceInverse = (0, typeGuards_1.isFuturesMarkPriceUpdate)(event) ? constants_1.BN_ONE.dividedBy(event.markPrice).toString() : constants_1.BN_ONE.dividedBy(event.lastPrice).toString();
            return Object.assign(Object.assign(Object.assign({}, acc), { [pair.baseAsset]: MarketData.insertQuote(asset, {
                    [pair.quoteAsset]: Number(price)
                }) }), (isInverse && !isHasQuoteSymbol ? {
                [pair.quoteAsset]: MarketData.insertQuote(inverseAsset, {
                    [pair.baseAsset]: Number(priceInverse)
                })
            } : {}));
        }, {});
        return eventsGroupedByBaseAsset;
    }
    updateUnknownSymbols(marketAssetsUpdated) {
        marketAssetsUpdated.forEach((marketAsset, baseAsset) => {
            const knownAsset = this.marketAssets.get(baseAsset);
            if (knownAsset === undefined) {
                this.marketAssets.set(baseAsset, marketAsset);
            }
            else {
                this.marketAssets.set(baseAsset, Object.assign(Object.assign({}, knownAsset), { quotes: Object.assign(Object.assign({}, knownAsset.quotes), marketAsset.quotes) }));
            }
        });
    }
}
exports.MarketData = MarketData;
class MarketDataSpot extends MarketData {
    constructor(params) {
        super(params);
        this.exchangeInfo = params.exchangeInfo;
    }
    filterEvents(events) {
        return formatted_1.eventFormattedFiltersMap[binance_1.EWsBinanceSpotMarketEventTypes.individualTicker](events);
    }
}
exports.MarketDataSpot = MarketDataSpot;
class MarketDataFutures extends MarketData {
    constructor(params) {
        super(params);
        this.exchangeInfo = params.exchangeInfo;
    }
    filterEvents(events) {
        return formatted_1.eventFormattedFiltersMap[binance_1.EWsBinanceFuturesMarketEventTypes.markPriceUpdate](events);
    }
}
exports.MarketDataFutures = MarketDataFutures;
